import { IonRippleEffect } from '@ionic/react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import ImageCarousel from '../../../../components/ImageCarousel';
import WishlistIcon from '../../wish-list/wish-list-icon';
import { ProductType } from '../../../../types/product';
import { useHistory, useLocation } from 'react-router';
import useGlobalContext from '../../../../context/provider';
import { getCurrentUser } from '../../../../utils/getClientInfo';
import { IoTrashBinOutline } from 'react-icons/io5';
import { FaMinus } from 'react-icons/fa6';
import { IoMdAdd } from 'react-icons/io';
import {
  deleteCartItem,
  getAllCartItems,
  updateCartItem,
} from '../../../../context/actions/cart';
import ErrorToast from '../../../../components/error_toast';
import Spinner from '../../../../components/spinner';

const SharedCartItem = ({
  product,
  customStyles,
}: {
  product: ProductType & { count: number };
  customStyles?: string;
}) => {
  const { images, id, name, price, views, store } = product;
  const { cartDispatch, cartState } = useGlobalContext();
  const history = useHistory();
  const client = getCurrentUser();
  const [path, setPath] = useState<string>('');
  const [isVendorView, setIsVendorView] = useState<boolean>(false);
  const [openError, setOpenError] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    setPath(`/${store?.name}/product/${name.slice(0, 30)}?id=${id}`);
  }, []);

  return (
    <div
      className={`relative flex flex-col w-full cursor-pointer  h-[270px] md:h-[320px] overflow-hidden ion-activatable ripple-parent circles shadow-xs bg-white ${customStyles}`}
      onClick={() => {
        history.push({
          pathname: path,
          state: { id },
        });
      }}
    >
      <ErrorToast
        isOpen={openError}
        message={error}
        onClose={() => {
          setOpenError(false);
        }}
        type="error"
        position="bottom"
      />
      <IonRippleEffect />
      <div className={'relative w-full  flex items-center h-[60%] md:h-[65%]'}>
        <ImageCarousel data={images} name={name} />
        {!isVendorView && (
          <div
            className="absolute  items-center bottom-2 right-2 z-10 cursor-pointer "
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <WishlistIcon productId={id} />
          </div>
        )}
        {views?.length! > 4 && (
          <div className="absolute italic rounded-sm text-xs text-white p-1 capitalize font-bold items-center top-0 left-0 z-10 cursor-pointer bg-secondary ">
            Trending
          </div>
        )}
      </div>
      <div className={'m-0 px-2 py-2 h-[40%] md:h-[35%]'}>
        <div className="w-full h-auto flex items-center justify-between">
          <p className="text-base font-light capitalize whitespace-nowrap overflow-hidden text-ellipsis ">
            {name}
          </p>
        </div>

        <div className="w-full text-md font-medium h-auto ">
          UGX
          {price.toLocaleString('en-US', {
            maximumFractionDigits: 2,
          })}
        </div>

        <div className="w-full h-auto flex items-center justify-between pt-2">
          <div className="w-fit h-auto flex items-center">
            <div
              className={
                ' h-auto mx-[4px] flex items-center justify-center text-xs md:text-base font-roboto font-semibold text-primary'
              }
            >
              <p className="font-normal font-roboto">Qt</p>
              <p className="border-2 border-primary cursor-pointer mx-[4px] px-[5px] md:px-[0.8rem] rounded-2xl">
                {product.count}
              </p>
            </div>
          </div>
          <div
            className="w-fit h-auto flex items-center justify-between cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              history.push(`/${product.store?.slug}`);
            }}
          >
            <p className="text-sm font-light capitalize whitespace-nowrap overflow-hidden text-ellipsis text-secondary">
              {product.store?.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedCartItem;
